import {PromiseBtnConfig} from './promise-btn-config';

export const DEFAULT_CFG: PromiseBtnConfig = {
  spinnerTpl: '<span class="btn-spinner"></span>',
  disableBtn: true,
  btnLoadingClass: 'is-loading',
  handleCurrentBtnOnly: false,
  minDuration: null,
};

